import React from 'react'
import Button from '../Button'

function CancelButton({ onClick }) {
  return <Button onClick={onClick} title="Закрыть" theme="bounded" color="black" border="gray" />
}

export default CancelButton
